import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __LanguagePreference extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly locale!: string;
  /**
   * @deprecated For backwards-compatibility only. Use translationLocale
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private translation_locale!: string;

  @Expose({groups: ['client']})
  public get translationLocale() {
    return this.translation_locale
  }

  public set translationLocale(value) {
    this.translation_locale = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use ignoredTranslations
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private ignored_translations!: string;

  @Expose({groups: ['client']})
  public get ignoredTranslations() {
    return this.ignored_translations
  }

  public set ignoredTranslations(value) {
    this.ignored_translations = value
  }
}
export type LanguagePreference = Omit<__LanguagePreference, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'translation_locale' | 'ignored_translations'>
export const LanguagePreference = __LanguagePreference as any as Constructor<LanguagePreference>
